/* Platform-clog store behaviours. Self-contained: own classes/attributes only,
   never touches Shrine's product-form / cart / variant custom elements. */
(function () {
  'use strict';

  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }

  /* Rails: arrows step one card, wrap round at either end (continuous) */
  function initRails(root) {
    root.querySelectorAll('[data-cl-rail]').forEach(function (rail) {
      if (rail.dataset.clReady) return; rail.dataset.clReady = '1';
      var track = rail.querySelector('.cl-rail__track');
      if (!track) return;
      function step() { var c = track.children[0]; if (!c) return 300; return c.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 16); }
      function go(dir) {
        var max = track.scrollWidth - track.clientWidth - 2;
        if (dir > 0 && track.scrollLeft >= max) { track.scrollTo({ left: 0, behavior: 'smooth' }); return; }
        if (dir < 0 && track.scrollLeft <= 2) { track.scrollTo({ left: track.scrollWidth, behavior: 'smooth' }); return; }
        track.scrollBy({ left: dir * step(), behavior: 'smooth' });
      }
      rail.querySelectorAll('[data-cl-prev]').forEach(function (b) { b.addEventListener('click', function () { go(-1); }); });
      rail.querySelectorAll('[data-cl-next]').forEach(function (b) { b.addEventListener('click', function () { go(1); }); });
    });
  }

  /* Strap demo: two-state toggle, plus one automatic swing the first time it scrolls into view */
  function initTwoWays(root) {
    root.querySelectorAll('[data-cl-twoways]').forEach(function (sec) {
      if (sec.dataset.clReady) return; sec.dataset.clReady = '1';
      var btns = sec.querySelectorAll('[data-mode-btn]');
      var touched = false;
      function set(mode) {
        sec.setAttribute('data-mode', mode);
        btns.forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-mode-btn') === mode ? 'true' : 'false'); });
      }
      btns.forEach(function (b) { b.addEventListener('click', function () { touched = true; set(b.getAttribute('data-mode-btn')); }); });
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (es) {
          es.forEach(function (e) {
            if (!e.isIntersecting) return; io.disconnect();
            var start = sec.getAttribute('data-mode');
            setTimeout(function () { if (!touched) set(start === 'back' ? 'forward' : 'back'); }, 900);
            setTimeout(function () { if (!touched) set(start); }, 2900);
          });
        }, { threshold: 0.5 });
        io.observe(sec);
      }
    });
  }

  /* Size finder */
  function initSize(root) {
    root.querySelectorAll('[data-cl-size]').forEach(function (sec) {
      if (sec.dataset.clReady) return; sec.dataset.clReady = '1';
      var chips = sec.querySelectorAll('[data-uk]');
      var eu = sec.querySelector('[data-out-eu]'), us = sec.querySelector('[data-out-us]'), uk = sec.querySelector('[data-out-uk]');
      chips.forEach(function (c) {
        c.addEventListener('click', function () {
          chips.forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
          c.setAttribute('aria-pressed', 'true');
          uk.textContent = c.getAttribute('data-uk'); eu.textContent = c.getAttribute('data-eu'); us.textContent = c.getAttribute('data-us');
        });
      });
    });
  }

  /* "Buy Now" links that should bring the visitor back to the buy box instead of reloading */
  function initScrollBuy(root) {
    root.querySelectorAll('[data-cl-scrollbuy]').forEach(function (a) {
      if (a.dataset.clReady) return; a.dataset.clReady = '1';
      a.addEventListener('click', function (e) {
        var target = document.querySelector('[id^="ProductInfo-"]') || document.querySelector('.product__info-container') || document.querySelector('product-form');
        if (!target) return;
        e.preventDefault();
        var y = target.getBoundingClientRect().top + window.pageYOffset - 90;
        window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
      });
    });
  }

  /* Gentle reveal */
  function initReveal(root) {
    var els = root.querySelectorAll('.cl-reveal:not(.is-in)');
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  function init(root) { initRails(root); initTwoWays(root); initSize(root); initScrollBuy(root); initReveal(root); }
  window.clReady = true;
  ready(function () { init(document); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
